import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";
import { CHAT_STREAM_INTERVAL_MS } from "./chat-playback";

type TStreamingTextProps = {
	text: string;
	/** Type the text out on mount; when false the full text renders immediately. */
	animate: boolean;
	className?: string;
};

export function StreamingText({ text, animate, className }: TStreamingTextProps) {
	const [count, setCount] = useState(animate ? 0 : text.length);

	useEffect(() => {
		if (!animate) {
			setCount(text.length);
			return;
		}
		const interval = window.setInterval(() => {
			setCount((current) => {
				if (current >= text.length) {
					window.clearInterval(interval);
					return current;
				}
				return current + 1;
			});
		}, CHAT_STREAM_INTERVAL_MS);
		return () => window.clearInterval(interval);
	}, [animate, text]);

	const streaming = count < text.length;

	return (
		<p className={cn("m-0", className)}>
			{text.slice(0, count)}
			{streaming ? <span className="landing-streaming-caret" aria-hidden="true" /> : null}
		</p>
	);
}
